/*
Reads @sidebase/nuxt-auth session state DIRECTLY from Nuxt's `useState` instead of
via `useAuth()` / `useAuthState()`.

Why: `useAuthState()` registers `onMounted` hooks (guarded by `getCurrentInstance()`).
When called inside route middleware during a client-side navigation that was triggered
from a component event handler (e.g. a button `@click` calling `router.push`),
`getCurrentInstance()` returns the *stale* instance of that component, so the hook is
registered on a dead instance — producing "onMounted is called when there is no active
component instance" warnings and a `Cannot read properties of null (reading 'type')`
crash on the next render.

These `useState` keys (`auth:data`, `auth:loading`) are sidebase's own internal state,
initialized by its plugin before any middleware runs. Reading them here is side-effect
free and safe in any context.
*/
export function useAuthSnapshot() {
  const data = useState('auth:data')
  const loading = useState('auth:loading')
  const status = computed(() =>
    loading.value ? 'loading' : (data.value ? 'authenticated' : 'unauthenticated')
  )
  return { data, status }
}
